import yousersjs from '@yola/yousersjs';
import { snakeCaseObjectToCamelCase } from 'src/js/utils/convert-case';

const fetchUserPreferences = async () => {
  try {
    const response = await yousersjs.preferences().get();
    const data = snakeCaseObjectToCamelCase(response.body);
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export default fetchUserPreferences;
